<template>
	<div id="techSupport">
		<NavigationBar />

		<div class="uk-section" 
				id="topBanner" 
				:style="{ backgroundImage: `url(${ banner })` }" >
			<div class="uk-container">
				<div class="uk-flex uk-flex-center uk-flex-middle uk-height-medium uk-height-max-small" uk-grid>
					<div class="uk-text-center">
						<p class="uk-text-large" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">We're Here to Help</p>
						<p class="uk-heading-small uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Contact</p>
					</div>
				</div>
			</div>
		</div>

		<div class="uk-section">
			<div class="uk-container">
				<div class="uk-flex uk-flex-center">
					<div class="uk-text-center">
						<p class="font-description uk-text-bolder uk-text-primary" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Let's Spark a Conversation</p>
						<h1 class="uk-text-bold" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Get in Touch with Us</h1>
						<p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">Need help with your purchase or have questions about our products?<br/>Our dedicated support team is here to help.<br/>Contact us today and let us know how we can assist you.</p>
					</div>
				</div>
			</div>
		</div>

		<div class="uk-section uk-padding-remove-top">
			<div class="uk-container">
				<div class="uk-grid-collapse uk-grid" uk-grid>
					<div class="uk-width-1-2@s">
						<div class="" uk-slideshow="autoplay: true" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: true;">
							<div class="uk-slideshow-items slider-contact">
								<div>
									<img :src="encodeURI('https://api.roomi.co.id/images/contact/aset website-10.jpg')" alt="" uk-cover>
									<div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="uk-width-1-2@s uk-padding-large uk-background-muted" uk-scrollspy="cls: uk-animation-slide-right; delay: 500; repeat: true;">
						<form @submit.prevent="submitMail()">
							<div class="uk-margin">
								<input type="text" name="name" class="uk-input" placeholder="Your Name" v-model="email.name">
							</div>
		
							<div class="uk-margin">
								<input type="email" name="email" class="uk-input" placeholder="Your Email Address" v-model="email.email">
							</div>
		
							<div class="uk-margin">
								<input type="text" name="subject" class="uk-input" placeholder="Subject Email" v-model="email.subject">
							</div>
		
							<div class="uk-margin">
								<textarea name="message" class="uk-textarea" rows="6" placeholder="Your Message" v-model="email.message"></textarea>
							</div>
							<div class="uk-margin">
								<button type="submit" class="uk-button uk-width-full uk-button-primary">SEND MESSAGE</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<h1 class="uk-heading-divider"></h1>
		<div class="uk-section">
			<div class="uk-container">
				<div class="uk-grid uk flex uk-flex-middle" uk-grid>
					<div class="uk-width-1-2@s">
						<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.6159121164646!2d106.70288230000001!3d-6.0473167000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f9c2e9a35f71%3A0xfa6084d51d31ec89!2sRoomi%20Store%20EDC%20PIK2!5e0!3m2!1sid!2sid!4v1705045124879!5m2!1sid!2sid" allowfullscreen="" loading="lazy" height="500" no-referrer-when-downgrade class="uk-width-full" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;"></iframe>
					</div>
					<div class="uk-width-1-2@s">
						<div class="">
							<!-- <div class="uk-text-center">
								<p class="font-description uk-text-bolder uk-text-primary" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Let's Spark a Conversation</p>
								<h1 class="uk-text-bold uk-margin-medium-bottom" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Get in Touch with Us</h1>
							</div> -->
							<div class="uk-grid" uk-grid>
								<div class="uk-width-1-2@s">
									<div class="uk-flex uk-flex-middle uk-flex-center ">
										<div class="uk-flex uk-flex-center uk-text-center uk-flex-column">
											<span uk-icon="icon: location; ratio: 2; bold" class="uk-margin-small-right" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;"></span>
											<p class="uk-text-bold uk-text-large uk-margin-remove-bottom" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Location :</p>
											<p class="font-description uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">IDD PIK2 Erajaya Digital Complex</p>
										</div>
									</div>
								</div>
								<div class="uk-width-1-2@s">
									<div class="uk-flex uk-flex-middle uk-flex-center ">
										<div class="uk-flex uk-flex-center uk-text-center uk-flex-column">
											<span uk-icon="icon: clock; ratio: 2; bold" class="uk-margin-small-right" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;"></span>
											<p class="uk-text-bold uk-text-large uk-margin-remove-bottom" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Timetable :</p>
											<p class="font-description uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">10:00 - 22:00 WIB</p>
										</div>
									</div>
								</div>
								<div class="uk-width-1-2@s">
									<div class="uk-flex uk-flex-middle uk-flex-center ">
										<div class="uk-flex uk-flex-center uk-text-center uk-flex-column">
											<span uk-icon="icon: receiver; ratio: 2; bold" class="uk-margin-small-right" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;"></span>
											<p class="uk-text-bold uk-text-large uk-margin-remove-bottom" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Call Us :</p>
											<p class="font-description uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">+62 8111 3901 291</p>
										</div>
									</div>
								</div>
								<div class="uk-width-1-2@s">
									<div class="uk-flex uk-flex-middle uk-flex-center ">
										<div class="uk-flex uk-flex-center uk-text-center uk-flex-column">
											<span uk-icon="icon: mail; ratio: 2; bold" class="uk-margin-small-right" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;"></span>
											<p class="uk-text-bold uk-text-large uk-margin-remove-bottom" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Write Us :</p>
											<p class="font-description uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">roomismarthome@gmail.com</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<h1 class="uk-heading-divider"></h1>
		<Footer />
	</div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'
import Footer from '@/components/Footer.vue'
import $axios from '../api.js'
import UIkit from 'uikit'

export default {
	name: 'techSupport',
	components: {
		NavigationBar,
		Footer
	},
	data () {
		return {
			banner: require('../assets/woman-in-white-blazer-holding-tablet-computer-789822EDIT.jpg'),
			email: {
				name: '',
				email: '',
				subject: '',
				message: ''
			}
		}
	},
	methods: {
		submitMail() {
			if (this.email.name == '' || this.email.email == '' || this.email.subject == '' || this.email.message == '') {
				UIkit.notification({
					status: 'danger',
					message: 'Please fill in all fields'
				})
			} else {
				$axios.post('customer/auth/send_email_contact_us', this.email).then(res => {
					if (res.status == 200) {
						const data = res.data
						if (data.success == 1) {
							this.email = {
								name: '',
								email: '',
								subject: '',
								message: ''
							}
							UIkit.notification({
								status: 'success',
								message: 'Email sent successfully'
							})
						} else {
							console.warn(data)
							UIkit.notification({
								status: 'error',
								message: 'Something went wrong'
							})
						}
					} else {
						console.log(res.status)
						UIkit.notification({
							status: 'danger',
							message: 'Something went wrong'
						})
					}
				}).catch(error => {
					console.warn(error)
					UIkit.notification({
						status: 'danger',
						message: 'Something went wrong'
					})
				})
			}
		},
		encodeURI(url) {
      return encodeURI(url);
    },
	}
}
</script>

<style scoped>
#topBanner {
	background-size: 125%;
	background-repeat: no-repeat;
	background-position-y: -20vw;
}

#topBanner h1 {
	font-size: 4vw;
	font-weight: 300;
	letter-spacing: 3.5px;
	word-spacing: 5px;
	width: 75%;
}
</style>